<script setup lang="ts">
import FdxIconCompareArrows from '~icons/icon/compare-arrows';
import FdxIconDashboard from '~icons/icon/dashboard-icon';
import FdxIconSettings from '~icons/icon/settings-icon';
import FdxIconArrowTopRight from '~icons/cashflow-icon/arrow_top_right';
import FdxIconGroup from '~icons/icon/group';
import FdxInsertChart from '~icons/icon/insert-chart';
import FdxIconCreditCard from '~icons/icon/credit-card';
import FdxIconStoreMallDirectory from '~icons/icon/store-mall-directory';
import FdxIconDescription from '~icons/icon/description';
import FdxIconLocalFlorist from '~icons/icon/local-florist';
import AuthorizedSidebarLink from './AuthorizedSidebarLink.vue';
import SadadLogo from '@/assets/images/logos/companies/sadad.svg';
</script>

<template>
    <aside
        class="bg-gray-100 border-e border-e-gray-200 max-h-full overflow-y-auto h-full"
        data-testid="nav-sidebar"
    >
        <div
            class="flex gap-x-2 border-b border-b-gray-200 px-2 py-3"
            data-testid="nav-logo-brand"
        >
            <div
                class="size-8 flex items-center justify-center bg-primary-500 rounded-md flex-shrink-0"
            >
                <FdxIconAccountBalance class="size-6 text-white" />
            </div>
            <span class="font-bold text-title-3">
                {{ $t('generic.common_terms.bank') }}
            </span>
        </div>

        <div class="px-2 py-3 max-h-full overflow-y-auto">
            <AuthorizedSidebarLink
                :to="{ name: 'dashboard' }"
                :title="$t('dashboard.title')"
                :icon="FdxIconDashboard"
                data-testid="nav-link-dashboard"
            />

            <AuthorizedSidebarLink
                :to="{ name: 'analytics' }"
                :title="$t('sidebar.analytics')"
                :icon="FdxInsertChart"
                data-testid="nav-link-analytics"
            />

            <span class="text-gray-700 py-3 mx-3 text-caption-1">
                {{ $t('sidebar.moneyMovement') }}
            </span>

            <AuthorizedSidebarLink
                :to="{ name: 'transactions' }"
                :title="$t('transactions.title')"
                :icon="FdxIconCompareArrows"
                data-testid="nav-link-transactions"
            />

            <AuthorizedSidebarLink
                :to="{ name: 'payments' }"
                :title="$t('payments.title')"
                :icon="FdxIconArrowTopRight"
                data-testid="nav-link-payments"
            />

            <AuthorizedSidebarLink
                :to="{ name: 'beneficiaries' }"
                :title="$t('beneficiaries.title')"
                :icon="FdxIconGroup"
                data-testid="nav-link-beneficiaries"
            />

            <span class="text-gray-700 py-3 mx-3 text-caption-1">
                {{ $t('sidebar.spendAndExpenses') }}
            </span>

            <AuthorizedSidebarLink
                :to="{ name: 'cards' }"
                :title="$t('sidebar.cards')"
                :icon="FdxIconCreditCard"
                data-testid="nav-link-cards"
                :comingSoon="true"
            />

            <AuthorizedSidebarLink
                :to="{ name: 'vendorPayments' }"
                :title="$t('sidebar.vendorPayments')"
                :icon="FdxIconStoreMallDirectory"
                data-testid="nav-link-vendor-payments"
                :comingSoon="true"
            />

            <AuthorizedSidebarLink
                :to="{ name: 'invoicePayments' }"
                :title="$t('sidebar.invoicePayments')"
                :icon="FdxIconDescription"
                data-testid="nav-link-invoice-payments"
                :newFeature="true"
            />

            <AuthorizedSidebarLink
                :to="{ name: 'sadad' }"
                :title="$t('sadad.title')"
                :img="SadadLogo"
                data-testid="nav-link-sadad"
            />

            <span class="text-gray-700 py-3 mx-3 text-caption-1">
                {{ $t('sidebar.funding') }}
            </span>

            <AuthorizedSidebarLink
                :to="{ name: 'capital' }"
                :title="$t('sidebar.capital')"
                :icon="FdxIconLocalFlorist"
                data-testid="nav-link-capital"
                :comingSoon="true"
            />

            <hr class="my-4" />

            <AuthorizedSidebarLink
                :to="{ name: 'settings' }"
                :title="$t('settings.title')"
                :icon="FdxIconSettings"
                data-testid="nav-link-settings"
            />
        </div>
    </aside>
</template>
